import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Link, Stack, useColorModeValue as mode } from '@chakra-ui/react';
import React from 'react';

const Paginate = ({ total, current, pageSize, onChange, disabled }) => {
  const propsStyles = {
    display: 'block',
    mx: '2px',
    py: 2,
    px: 4,
    borderRadius: 'md',
    transition: 'all 0.3s',
    fontWeight: 'medium',
    lineHeight: '1.25rem',
  };
  const propsBtn = {
    width: {
      base: '60px',
    },
    mx: '2px',
    bg: 'transparent',
    _hover: {
      bg: mode('amatrium.500', 'grey.400'),
    },
  };
  const PAGE_SIZE = pageSize ? pageSize : 10;
  const CURRENT = current ? current : 1;
  const TOTAL = total ? total : 0;
  const NUMBER_PAGE = Math.ceil(TOTAL / PAGE_SIZE);

  const renderPage = () => {
    let arrayComponent = [];
    for (let i = CURRENT - 2; i <= CURRENT + 2; i++) {
      if (i > 0 && i <= NUMBER_PAGE)
        arrayComponent.push(
          <Link
            {...propsStyles}
            key={i}
            aria-current={i === CURRENT ? 'page' : undefined}
            onClick={() => onChange && onChange(i, PAGE_SIZE)}
            variant='button'
          >
            {i}
          </Link>
        );
    }
    return arrayComponent;
  };

  return (
    <Flex pos='relative' align='center' justify='end' w='100%' h='100%' px='8'>
      {TOTAL !== 0 && (
        <Flex pos='relative' align='center' w='max-content' h='100%'>
          {/* disable overlay  */}
          {disabled && (
            <Stack
              pos='absolute'
              zIndex='200'
              w='100%'
              h='100%'
              bg='gray.100'
              opacity='0.5'
              borderRadius='2px'
            ></Stack>
          )}
          <IconButton
            isDisabled={CURRENT === 1}
            {...propsBtn}
            onClick={() => onChange && onChange(1, PAGE_SIZE)}
          >
            <ArrowLeftIcon h={3} w={3} />
          </IconButton>
          <IconButton
            isDisabled={CURRENT === 1}
            {...propsBtn}
            onClick={() => onChange && onChange(CURRENT - 1, PAGE_SIZE)}
          >
            <ChevronLeftIcon h={6} w={6} />
          </IconButton>
          {renderPage()}
          <IconButton
            isDisabled={CURRENT === NUMBER_PAGE}
            {...propsBtn}
            onClick={() => onChange && onChange(CURRENT + 1, PAGE_SIZE)}
          >
            <ChevronRightIcon h={6} w={6} />
          </IconButton>
          <IconButton
            isDisabled={CURRENT === NUMBER_PAGE}
            {...propsBtn}
            onClick={() => onChange && onChange(NUMBER_PAGE, PAGE_SIZE)}
          >
            <ArrowRightIcon h={3} w={3} />
          </IconButton>
        </Flex>
      )}
    </Flex>
  );
};

export default Paginate;
